export const fr: Record<string, string> = {

  // ── Breadcrumb ──
  'Dashboard': 'Tableau de bord',
  'Profile': 'Profil',

  // ── Tab Labels ──
  'Personal Details': 'Informations personnelles',
  'Demographics': 'Données démographiques',
  'Medical History': 'Antécédents médicaux',
  'Insurance Information': 'Informations d\'assurance',
  'Documents': 'Documents',
  'Settings': 'Paramètres',

  // ── Personal Details Tab ──
  'Mahi': 'Mahi',

  'Manage your basic details, contact information, and emergency contacts using the sections below.': 'Gérez vos informations de base, vos coordonnées et vos contacts d\'urgence dans les sections ci-dessous.',
  'Profile Photo': 'Photo de profil',
  'Basic Details': 'Informations de base',
  'First Name': 'Prénom',
  'Last Name': 'Nom de famille',
  'Date of Birth': 'Date de naissance',
  'Address': 'Adresse',
  'City': 'Ville',
  'State': 'État',
  'ZIP Code': 'Code postal',
  'Country': 'Pays',
  'Care Team': 'Équipe soignante',
  'Internal Co-manager': 'Co-gestionnaire interne',
  'External Co-manager': 'Co-gestionnaire externe',
  'Primary Care Physician': 'Médecin traitant',
  'Referral': 'Référence',
  'Contact Information': 'Coordonnées',
  'Email': 'Courriel',
  'Mobile Number': 'Numéro de portable',
  'Emergency Contact Information': 'Contact d\'urgence',
  'Name': 'Nom',
  'Relation': 'Lien de parenté',
  'Communication Preference': 'Préférence de communication',
  'SMS': 'SMS',

  // ── Demographics Tab ──
  'Demographics & Personal Background': 'Données démographiques et profil personnel',
  'Review and update your personal information, language preferences, and identity details to help us provide better care.': 'Consultez et mettez à jour vos informations personnelles, vos préférences linguistiques et vos informations d\'identité pour nous aider à mieux vous soigner.',
  'Details': 'Détails',
  'Ethnicity': 'Ethnicité',
  'Race': 'Origine',
  'Preferred Language': 'Langue préférée',
  'Expressions': 'Expressions',
  'Proficiency': 'Niveau de maîtrise',
  'Sexual Orientation': 'Orientation sexuelle',
  'Gender Identity': 'Identité de genre',
  'Multiple Births': 'Naissances multiples',

  // ── Medical History Tab ──
  'Review your medical history summary here, and click the Edit button to update any details.': 'Consultez le résumé de vos antécédents médicaux ici et cliquez sur le bouton Modifier pour mettre à jour les informations.',
  'Medical Conditions': 'Conditions médicales',
  'Lifestyle Factors': 'Facteurs liés au mode de vie',
  'Alcohol Consumption': 'Consommation d\'alcool',
  'Smoking': 'Tabagisme',
  'Drugs Use': 'Consommation de drogues',
  'Current Medications': 'Médicaments actuels',
  'Allergies': 'Allergies',
  'Is there anything else we should know?': 'Y a-t-il autre chose que nous devrions savoir ?',
  'Monitor for any signs of allergic reaction, and administer antihistamines as needed.': 'Surveiller tout signe de réaction allergique et administrer des antihistaminiques si nécessaire.',

  // ── Insurance Tab ──
  'Review and manage your insurance coverage details': 'Consultez et gérez les détails de votre couverture d\'assurance',
  'Coverage Type': 'Type de couverture',
  'Payor': 'Payeur',
  'Plan': 'Plan',
  'Policy Holder': 'Titulaire de la police',
  'Policy ID': 'Numéro de police',
  'Group ID': 'Numéro de groupe',
  'Effective Date': 'Date d\'entrée en vigueur',
  'Expiry Date': 'Date d\'expiration',
  'Insurance Card Images': 'Images de la carte d\'assurance',

  // ── Documents Tab ──
  'Files & Records': 'Fichiers et dossiers',
  'Download, review, or update your documents.': 'Téléchargez, consultez ou mettez à jour vos documents.',
  'Action': 'Action',
  'No documents found': 'Aucun document trouvé',
  'Download': 'Télécharger',
  'Delete': 'Supprimer',

  // ── Settings Tab ──
  'Account & Preferences': 'Compte et préférences',
  'Manage your account details, security settings, and communication preferences.': 'Gérez les détails de votre compte, les paramètres de sécurité et les préférences de communication.',
  'Account': 'Compte',
  'Change Password': 'Changer le mot de passe',
  'Login Activity': 'Activité de connexion',
  'Preferences': 'Préférences',
  'Language': 'Langue',

  // ── Change Password Modal ──
  'Current Password': 'Mot de passe actuel',
  'Enter current password': 'Saisir le mot de passe actuel',
  'Current password is required.': 'Le mot de passe actuel est obligatoire.',
  'Password must be at least 8 characters.': 'Le mot de passe doit comporter au moins 8 caractères.',
  'New Password': 'Nouveau mot de passe',
  'Enter new password': 'Saisir le nouveau mot de passe',
  'New password is required.': 'Le nouveau mot de passe est obligatoire.',
  'Confirm New Password': 'Confirmer le nouveau mot de passe',
  'Re-enter new password': 'Ressaisir le nouveau mot de passe',
  'Please confirm your new password.': 'Veuillez confirmer votre nouveau mot de passe.',
  'Passwords do not match.': 'Les mots de passe ne correspondent pas.',
  'Cancel': 'Annuler',
  'Save Changes': 'Enregistrer les modifications',

  // ── Login Activity Modal ──
  'Current': 'En cours',
  'Sign Out': 'Se déconnecter',
  'Sign Out of Other Devices': 'Se déconnecter des autres appareils',

  // ── Unsaved Changes Modal ──
  'Unsaved Changes': 'Modifications non enregistrées',
  'You have unsaved changes. If you switch tabs, your edits won\'t be saved. Do you still want to proceed?': 'Vous avez des modifications non enregistrées. Si vous changez d\'onglet, vos modifications ne seront pas sauvegardées. Voulez-vous quand même continuer ?',
  'No': 'Non',
  'Yes': 'Oui',

















  //Prescriptions
  'Prescriptions': 'Ordonnances',
  'View your active medications and download your prescriptions.': 'Consultez vos médicaments actifs et téléchargez vos ordonnances.',

  // ── Left Panel ──
  'Prescription List': 'Liste des ordonnances',

  // ── Right Panel ──
  'Download Prescription': 'Télécharger l\'ordonnance',

  // ── Medication Summary ──
  'Medications Prescribed': 'Médicaments prescrits',

  // ── Medication Details ──
  'Duration:': 'Durée :',
  'Quantity': 'Quantité',
  'Days Supply': 'Jours d\'approvisionnement',
  'Refills Left': 'Renouvellements restants',
  'Prescribed By': 'Prescrit par',
  'Medication Instructions': 'Instructions médicamenteuses',

  // ── Empty State ──
  'No Prescriptions prescribed': 'Aucune ordonnance prescrite',

  // ── Mobile ──
  'View Details': 'Voir les détails',

  // ── Refill Modal ──
  'Request medication refill?': 'Demander un renouvellement de médicament ?',
  'This request will be sent to your care team for review. You\'ll be notified once it\'s processed.': 'Cette demande sera envoyée à votre équipe soignante pour examen. Vous serez notifié une fois qu\'elle sera traitée.',

  // ── Toast ──
  'Your request has been sent!': 'Votre demande a été envoyée !',

  // ── Need Help Offcanvas ──
  'Need Help?': 'Besoin d\'aide ?',
  'We are here to assist you': 'Nous sommes là pour vous aider',
  'Our support team is available': 'Notre équipe d\'assistance est disponible',
  'Monday - Friday, 8:00 AM': 'Lundi - Vendredi, 8h00',
  'to': 'à',
  '6:00 PM': '18h00',
  'EST. Call or text us for assistance with your profile, appointments, or any questions.': 'HNE. Appelez-nous ou envoyez un message pour obtenir de l\'aide concernant votre profil, vos rendez-vous ou toute autre question.',
  'Call': 'Appeler',
























  'My Visits': 'Mes consultations',
  'Forms': 'Formulaires',
  'Activity Logs': 'Journaux d\'activité',
  'Education Library': 'Bibliothèque éducative',
  'Logout Account': 'Déconnexion',

  // ── Desktop Header ──
  'Clinic Support:': 'Support clinique :',



















  'My Onboarding Forms': 'Mes formulaires d\'intégration',
  'Start a new form or continue with your pending ones.': 'Commencez un nouveau formulaire ou continuez avec ceux en attente.',

  // ── Table Headers ──
  'S.No': 'N°',
  'Doctor Name': 'Nom du médecin',
  'Appointment Date & Time': 'Date et heure du rendez-vous',
  'Status': 'Statut',
  'Actions': 'Actions',

  // ── Section Headings ──
  'Upcoming Appointments': 'Rendez-vous à venir',
  'Previous Appointments': 'Rendez-vous précédents',

  // ── Status Labels ──
  'New': 'Nouveau',
  'Pending': 'En attente',
  'Submitted': 'Soumis',
  'Reviewed': 'Examiné',

  // ── Action Buttons ──
  'Start Onboarding Form': 'Commencer le formulaire d\'intégration',
  'Continue Filling Form': 'Continuer à remplir le formulaire',
  'View/Edit Form': 'Voir / Modifier le formulaire',
  'View Form': 'Voir le formulaire',

  // ── Empty State ──
  'No Upcoming Appointments': 'Aucun rendez-vous à venir',
  'You have no scheduled or appointments.': 'Vous n\'avez aucun rendez-vous planifié.',

  // ── Onboarding Offcanvas ──
  'Onboarding Summary': 'Résumé d\'intégration',
  'Review your details. Click \'Edit the form\' to update the information.': 'Vérifiez vos informations. Cliquez sur « Modifier le formulaire » pour mettre à jour les données.',
  'Edit the form': 'Modifier le formulaire',




























  'Education Video Library': 'Bibliothèque de vidéos éducatives',
  'Learn about your eye health and upcoming procedures.': 'Renseignez-vous sur la santé de vos yeux et les procédures à venir.',

  'Ordered By': 'Prescrit par',
  'Sent On': 'Envoyé le',
  'Procedure': 'Procédure',

  // ── Education Library Actions ──
  'Watch': 'Visionner',
  'View Image': 'Voir l\'image',
  'View PDF': 'Voir le PDF',
  'Play Video': 'Lire la vidéo',
  'Open Document': 'Ouvrir le document',

  // ── Education Library Empty State ──
  'No documents available': 'Aucun document disponible',

  // ── Dashboard Header ──
  'Welcome': 'Bienvenue',
  'Documents shared by your care team': 'Documents partagés par votre équipe soignante',
  'Manage your visits, bills, and health information in one place.': 'Gérez vos consultations, factures et informations de santé en un seul endroit.',

  // ── Dashboard Quick Actions (Mobile) ──
  'Book Appt': 'Prendre RDV',
  'Bill Pay': 'Payer la facture',
  'Insurance': 'Assurance',

  // ── Dashboard Quick Actions (Desktop) ──
  'Book Appointment': 'Prendre un rendez-vous',

  // ── Dashboard Upcoming Appointments ──
  'View All Forms': 'Voir tous les formulaires',
  'at': 'à',
  'Reschedule Requested': 'Reprogrammation demandée',
  'Rescheduled': 'Reprogrammé',
  'Completed': 'Terminé',
  'Cancelled': 'Annulé',
  'Fill Onboarding Form': 'Remplir le formulaire d\'intégration',
  'Continue Filling Onboarding form': 'Continuer à remplir le formulaire d\'intégration',

  // ── Dashboard Carousel Slides ──
  'Buy One, Get One on Contact Lenses': 'Un acheté, un offert sur les lentilles de contact',
  'Stock up and save on your vision needs.': 'Faites des réserves et économisez sur vos besoins visuels.',
  '20% Off Eyeglasses': '20 % de réduction sur les lunettes',
  'Trendy frames for every face.': 'Des montures tendance pour chaque visage.',
  'Free Eye Checkup': 'Bilan visuel gratuit',
  'Limited time offer with purchases.': 'Offre à durée limitée avec tout achat.',

  // ── Dashboard Billing ──
  'Billing Status': 'État de facturation',
  'Outstanding Balance': 'Solde impayé',
  'Pay Now': 'Payer maintenant',
  'View Statement': 'Voir le relevé',
  'Billing not started yet': 'Facturation non encore commencée',
  'No outstanding balance. Your account is in good standing.': 'Aucun solde impayé. Votre compte est en règle.',

  // ── Dashboard Vision ──
  'Vision Summary': 'Résumé de la vision',
  'Last Vision Values': 'Dernières valeurs visuelles',
  'Right Eye': 'Œil droit',
  'Left Eye': 'Œil gauche',
  'Glass Prescription': 'Ordonnance de lunettes',
  'SPH': 'SPH',
  'CYL': 'CYL',
  'AXIS': 'AXE',
  'No vision data on file': 'Aucune donnée visuelle enregistrée',
  'Complete your first eye exam to see your vision summary here.': 'Effectuez votre premier examen de la vue pour voir votre résumé visuel ici.',

  // ── Dashboard Reminders ──
  'Reminders & Alerts': 'Rappels et alertes',
  'Remind me': 'Me rappeler',
  'No Alerts!': 'Aucune alerte !',

  // ── Dashboard Recent Visits ──
  'Recent Visits': 'Consultations récentes',
  'View All Visits': 'Voir toutes les consultations',
  'No visit history yet': 'Aucun historique de consultation',
  'Your past appointments and visit records will appear here.': 'Vos rendez-vous passés et dossiers de consultation apparaîtront ici.',
  'No Show': 'Absence',

  'Book an appointment with your optometrist to get started.': 'Prenez rendez-vous avec votre opticien pour commencer.',

  'View Library': 'Voir la bibliothèque',
  'Patient has no insurances': 'Le patient n\'a aucune assurance',
  'Support Phone Number': 'Numéro de téléphone d\'assistance',

  // ── Reschedule Popovers ──
  'Reschedule Remarks': 'Remarques sur la reprogrammation',
  'Reschedule Details': 'Détails de la reprogrammation',
  'New Appointment': 'Nouveau rendez-vous',
  'This appointment is rescheduled to': 'Ce rendez-vous est reprogrammé au',
  'Reason:': 'Motif :',

  // ── Card Payment Modal ──
  'Card Payment': 'Paiement par carte',

  'A record of what you viewed, downloaded, or changed': 'Un enregistrement de ce que vous avez consulté, téléchargé ou modifié',
  'Filter': 'Filtrer',

  // ── Activity Logs Filter Form ──
  'From Date': 'Date de début',
  'To Date': 'Date de fin',
  'Log Type': 'Type de journal',
  'Search': 'Rechercher',
  'Select All': 'Tout sélectionner',
  'Date': 'Date',
  'Time': 'Heure',
  'Description': 'Description',

  // ── Activity Log Type Badges ──
  'Accessed': 'Consulté',
  'Exported': 'Exporté',
  'Transmitted': 'Transmis',
  'Downloaded': 'Téléchargé',
  'Added': 'Ajouté',
  'Deleted': 'Supprimé',
  'Edited': 'Modifié',
  'Login': 'Connexion',
  'Logout': 'Déconnexion',

  // ── Activity Logs Pagination ──
  'Back': 'Précédent',
  'Next': 'Suivant',

  // ── Activity Logs Mobile Filter ──
  'Date Range': 'Plage de dates',
  'From': 'Du',
  'To': 'Au',
  'Reset': 'Réinitialiser',
  'Apply Filters': 'Appliquer les filtres',
























  'Review your health summaries, download official case sheets, and share them anytime.':
    'Consultez vos résumés de santé, téléchargez les fiches de cas officielles et partagez-les à tout moment.',
  'Download Visit Summary': 'Télécharger le Résumé de Visite',

  // Appointment Sections
  'Current Appointments': 'Rendez-vous Actuels',

  // Appointment Details
  'Provider': 'Prestataire',
  'Surgery': 'Chirurgie',
  'Location': 'Emplacement',

  // Status Labels
  'Confirmed': 'Confirmé',
  'Not Confirmed': 'Non Confirmé',
  'Active': 'Actif',
  'InActive': 'Inactif',

  // Dropdown Actions
  'View visit summary': 'Voir le résumé de visite',
  'Export visit summary': 'Exporter le résumé de visite',
  'View summary': 'Voir le résumé',
  'View technical data (CCDA format)': 'Voir les données techniques (format CCDA)',
  'Share via email': 'Partager par e-mail',
  'Send Reschedule Request': 'Envoyer une demande de reprogrammation',
  'FG Rx Print': 'Impression FG Rx',

  // No Data
  'No Appointments Found': 'Aucun Rendez-vous Trouvé',
  'You have no scheduled or past appointments.':
    "Vous n'avez pas de rendez-vous planifiés ou passés.",

  // Mobile View
  'Show details': 'Afficher les détails',

  // Download Visit Summary Popup
  'Download Visit Summary Title': 'Télécharger le Résumé de Visite',
  'Provider Name': 'Nom du Prestataire',
  'Appt. Date': 'Date du RDV',
  'Visit Reason': 'Motif de Visite',
  'Last Exported By': 'Dernier Exporté Par',
  'Last Export Date': "Date du Dernier Export",
  'No Data Found': 'Aucune Donnée Trouvée',

  // Consultation Summary Popup
  'Consultation Summary': 'Résumé de Consultation',
  'Download Button': 'Télécharger',
  'Chief Complaints': 'Plaintes Principales',
  'Review of Systems': 'Revue des Systèmes',
  'Ocular History': 'Antécédents Oculaires',
  'Ocular Surgical History': 'Antécédents Chirurgicaux Oculaires',
  'Current Eye Medication': 'Médicaments Oculaires Actuels',
  'Past Medical History': 'Antécédents Médicaux',
  'Surgical History': 'Antécédents Chirurgicaux',
  'Current Systemic Medication': 'Médicaments Systémiques Actuels',
  'Family History': 'Antécédents Familiaux',
  'Functional Status': 'État Fonctionnel',
  'Menstrual History': 'Antécédents Menstruels',
  'Vaccination History': 'Antécédents de Vaccination',
  'Birth History': 'Antécédents de Naissance',
  'Nutritional History': 'Antécédents Nutritionnels',
  'Physical Evaluation': 'Évaluation Physique',
  'Implants': 'Implants',
  'Psychological Observations': 'Observations Psychologiques',
  'Lifestyle History': 'Antécédents de Style de Vie',
  'Psychiatry': 'Psychiatrie',
  'Health Concerns & Goals': 'Préoccupations et Objectifs de Santé',
  'Lab & Investigation': 'Laboratoire et Investigation',
  'Vitals': 'Constantes Vitales',
  'Fall Risk Assessment': "Évaluation du Risque de Chute",

  // Table Headers - Review of Systems
  'Medical Condition': 'Condition Médicale',
  'Sub Relation': 'Sous-relation',
  'Age': 'Âge',
  'Concern Expressed by': 'Préoccupation Exprimée Par',
  'Goals Expressed by': 'Objectifs Exprimés Par',
  'Onset': 'Début',
  'Start Date': 'Date de Début',
  'End Date': 'Date de Fin',
  'Result Value': 'Valeur du Résultat',
  'Medicine & ROA': 'Médicament et Voie d\'Administration',
  'Refills': 'Renouvellements',
  'Vaccine & Manufacturer': 'Vaccin et Fabricant',
  'Dosage': 'Dosage',
  'Habit': 'Habitude',
  'Consumption': 'Consommation',
  'Assessment Criteria': "Critères d'Évaluation",
  'Response': 'Réponse',
  'Score': 'Score',

  // Vitals
  'Temperature': 'Température',
  'Pulse': 'Pouls',
  'BP-Systolic': 'PA-Systolique',
  'BP-Diastolic': 'PA-Diastolique',
  'Resp. Rate': 'Fréquence Respiratoire',
  'SpO2': 'SpO2',
  'Inh. O2 Conc.': 'Conc. O2 Inhalé',
  'BGL': 'Glycémie',
  'HOFC Perc.': 'Perc. HOFC',
  'Weight': 'Poids',
  'Height': 'Taille',
  'BMI': 'IMC',
  'Heart Rate': 'Fréquence Cardiaque',

  // Dilation
  'Dilation': 'Dilatation',
  'Eye': 'Œil',
  'Drops': 'Gouttes',
  'Frequency': 'Fréquence',
  'Start Time': 'Heure de Début',
  'Notes': 'Notes',
  'No, Dilation has not been performed for this visit':
    "Non, la dilatation n'a pas été effectuée pour cette visite",

  // Vision and Perception
  'Vision and Perception': 'Vision et Perception',
  'Visual Acuity': 'Acuité Visuelle',
  'Auto Refraction': 'Auto-réfraction',
  'Retinoscopy': 'Rétinoscope',
  'Present Glass Rx': 'Prescription de Lunettes Actuelle',
  'Manifest Refraction': 'Réfraction Manifeste',
  'Final Glass Rx': 'Prescription Finale de Lunettes',
  'Cycloplegic Refraction': 'Réfraction Cyclopléjique',
  'Over Refraction': 'Sur-réfraction',
  'Pachymetry': 'Pachymétrie',
  'IOP (Tonometry)': 'PIO (Tonomérie)',
  'Pupil Size': 'Taille de la Pupille',
  'PAM (Potential Acuity Meter)': 'PAM (Mètre d\'Acuité Potentielle)',
  'Keretometry': 'Kératomérie',
  'Glare': 'Éblouissement',

  // Vision Table Headers
  'SC-(D)': 'SC-(D)',
  'SC-(N)': 'SC-(N)',
  'CC-(GL)(D)': 'CC-(GL)(D)',
  'CC-(GL)(N)': 'CC-(GL)(N)',
  'CC-(CL)(D)': 'CC-(CL)(D)',
  'CC-(CL)(N)': 'CC-(CL)(N)',
  'Pinhole(D)': 'Sténopé(D)',
  'TAC(D)': 'TAC(D)',
  'Sph': 'Sph',
  'Cyl': 'Cyl',
  'Axis': 'Axe',
  'Add': 'Addition',
  'Prism': 'Prisme',
  'Type': 'Type',
  'Duo': 'Duo',
  'Cs': 'Cs',
  'VA (D)': 'AV (L)',
  'VA (N)': 'AV (P)',
  'VA (I)': 'AV (I)',

  // Pachymetry Table
  'H Axis': 'Axe H',
  'V Axis': 'Axe V',
  'Avg. K Value': 'Valeur K Moy.',
  'Cyl Value': 'Valeur Cyl',
  'Average': 'Moyenne',
  'Given by': 'Donné Par',
  'Device': 'Appareil',
  'OD CC': 'OD CC',
  'OS CC': 'OS CC',

  // Contact Lens
  'Contact Lens - Soft Contact Lens': 'Lentille de Contact - Lentille Souple',
  'RGP ( Rigid Gas Permeable )': 'RGP (Rigide Perméable aux Gaz)',
  'Wearing': 'Port',
  'Trail': 'Essai',
  'Final': 'Final',
  'Dispensed Trial': 'Essai Dispensé',
  'Manufacturer': 'Fabricant',
  'Series': 'Série',
  'BC': 'RC',
  'Diameter': 'Diamètre',
  'Colour': 'Couleur',
  'Rx Expiration': "Expiration de l'Ordonnance",
  'Replacement Schedule': 'Calendrier de Remplacement',
  'Wearing Instruction': 'Instruction de Port',
  'Advance': 'Avancé',
  'Fit': 'Adaptation',
  'Comfort': 'Confort',
  'Centration': 'Centrage',
  'Coverage': 'Couverture',
  'Movement': 'Mouvement',
  'Degree': 'Degré',
  'Direction': 'Direction',
  'Added by': 'Ajouté Par',

  // Examination
  'Examination': 'Examen',
  'Anterior Segment': 'Segment Antérieur',
  'Posterior Segment': 'Segment Postérieur',
  'Gonioscopy': 'Gonioscopie',
  'Motor Examinations': 'Examens Moteurs',
  'Extra Ocular Motility': 'Motilité Extra-oculaire',
  'Ductions': 'Ductions',
  '9 Gaze Evaluation': 'Évaluation des 9 Positions du Regard',
  'Squint Evaluation': 'Évaluation du Strabisme',
  'Cover/Alternate Cover Test': 'Test de Cover / Cover Alterné',
  'Corneal Reflex / HCRT': 'Réflexe Cornéen / HCRT',
  'Prism Cover / Alternate Cover Test': 'Test de Prisme et Cover / Alterné',
  'Nystagmus': 'Nystagmus',
  'Head Posture': 'Posture de la Tête',
  'Binocular Vision Test': 'Test de Vision Binoculaire',
  'Worth Four Dot Test': 'Test des Quatre Points de Worth',
  'Near Point Convergence': 'Point Proche de Convergence',
  'Fusional Vergence': 'Vergence Fusionnelle',
  'Near Point Accomodation': "Point Proche d'Accommodation",
  'Stereopsis': 'Stéréopsie',
  'Additional Examinations': 'Examens Supplémentaires',
  'Dry Eye Evaluation': "Évaluation de l'Œil Sec",
  'Color Vision Test': 'Test de Vision des Couleurs',
  'Lacrimal Patency': 'Perméabilité Lacrymale',
  'Amsler Grid': "Grille d'Amsler",
  '4 Field Test': 'Test à 4 Champs',
  '8 Field Test': 'Test à 8 Champs',

  // Assessments
  'Assessments': 'Évaluations',
  'Site': 'Site',
  'Priority': 'Priorité',
  'Severity & Status': 'Gravité et Statut',
  'Plan Of Discussions': 'Plan de Discussions',
  'Patient Instructions': 'Instructions au Patient',
  'Doctor Notes': 'Notes du Médecin',
  'Other Actions Taken': 'Autres Actions Entreprises',
  'Investigations': 'Investigations',

  // Orders
  'Orders': 'Ordonnances',
  'Investigation': 'Investigation',
  'Procedure Details': 'Détails du Procédure',
  'Surgery Details': 'Détails de la Chirurgie',
  'Cost Estimated': 'Coût Estimé',
  'Patient Education': 'Éducation du Patient',
  'Return to Office': 'Retour au Cabinet',

  // Super Bill
  'Super Bill': 'Super Facture',
  'Suggested Procedure': 'Procédure Suggérée',
  'Unit': 'Unité',
  'Modifier': 'Modificateur',
  'Additional Diagnosis': 'Diagnostic Supplémentaire',

  // Medical Rx
  'Medical Rx': 'Ordonnance Médicale',
  'Medicine Orders': 'Ordonnances de Médicaments',
  'Glass Rx': 'Ordonnance de Lunettes',
  'E Rx Sent': 'Ordonnance Électronique Envoyée',
  'E Rx Pending': 'Ordonnance Électronique en Attente',
  'Medication Stopped': 'Médicament Arrêté',

  // Procedures Section
  'Procedures': 'Procédures',
  'Operative Notes': 'Notes Opératoires',
  'Post Op Instructions': 'Instructions Post-Opératoires',
  'Complications': 'Complications',
  'Pre Med': 'Pré-Médication',
  'Intra Med': 'Intra-Médication',
  'Post Med': 'Post-Médication',
  'Observations': 'Observations',
  'Additional Information': 'Informations Supplémentaires',

  // Staff
  'Staff': 'Personnel',
  'Scriber': 'Scribe',
  'Consultation Notes': 'Notes de Consultation',
  'Patient Notes': 'Notes du Patient',

  // View Summary Popup
  'View Summary': 'Voir le Résumé',
  'ASC Download': 'Téléchargement ASC',
  'Operative Notes Tab': 'Notes Opératoires',
  'Discharge Summary': 'Résumé de Sortie',
  'Pre-op Dx': 'Dx Pré-opératoire',
  'Post-op Dx': 'Dx Post-opératoire',
  'Pre-Op Diagnosis': 'Diagnostic Pré-Opératoire',
  'Post-Op Diagnosis': 'Diagnostic Post-Opératoire',
  'Procedure (Description)': 'Procédure (Description)',
  'Anesthesia Type': "Type d'Anesthésie",
  'Findings': 'Résultats',
  'Surgeon Operative Notes': 'Notes Opératoires du Chirurgien',
  'Pathology': 'Pathologie',
  'Code Implants': 'Implants par Code',
  'Other Codes': 'Autres Codes',
  'Others Implants': 'Autres Implants',
  'Post Procedure Note': 'Note Post-Procédure',
  'Patients Instructions': 'Instructions au Patient',
  'Post OP Medications': 'Médicaments Post-Opératoires',
  'Medication Orders': 'Ordonnances de Médicaments',
  'Lab/Investigations': 'Laboratoire/Investigations',
  'Comments': 'Commentaires',
  'Reviewed By': 'Revu Par',
  'Signed by': 'Signé Par',
  'Examinations/Findings': 'Examens/Résultats',
  'Post Procedures Notes': 'Notes Post-Procédure',
  'Patient Instructions Discharge': 'Instructions au Patient',
  'Final disposition': 'Disposition Finale',
  'Patient Condition on Discharge': 'Condition du Patient à la Sortie',
  'Co-Management': 'Co-Gestion',
  'Follow-Up': 'Suivi',
  'Signatures': 'Signatures',
  'Patient Name': 'Nom du Patient',
  'Nurse Name': "Nom de l'Infirmière",
  'Accompanied By': 'Accompagné Par',

  // Email Popup
  'Normal Email': 'E-mail Normal',
  'PDF Label': 'PDF',
  'To Mail': 'À',
  'Subject': 'Sujet',
  'Body': 'Corps',
  'Send Request': 'Envoyer la Demande',

  // Reschedule Popup
  'Manage Appointment': 'Gérer le Rendez-vous',
  'Please tell us why you\'d like to reschedule or cancel your appointment':
    'Veuillez nous indiquer pourquoi vous souhaitez reprogrammer ou annuler votre rendez-vous',
  'Enter your reason': 'Entrez votre raison',
  'Reason is required': 'La raison est requise',
  'Please enter a valid email': 'Veuillez entrer un e-mail valide',
  'Subject is required': 'Le sujet est requis',


  // Export History Popover
  'Export History': "Historique d'Exportation",

  // Common
  'General': 'Général',
  'OD': 'OD',
  'OS': 'OS',
  'OU': 'OU',
  'Deferred': 'Différé',
  'Refused': 'Refusé',
  'Torch Used': 'Lampe Utilisée',
  'SLE Drawing': 'Dessin à la Lampe à Fente',
  'Fundus Drawing': 'Dessin du Fond',
  'Drawing Images': 'Images de Dessin',
  'Extended Ophthomology': 'Ophtalmologie Étendue',
  'Lens Used': 'Lentille Utilisée',
  'Full And Freely Moving In All Directions': 'Mouvement Complet et Libre dans Toutes les Directions',
  'Limitation of': 'Limitation de',
  'Alphabet Pattern': 'Schéma Alphabétique',
  'All Other Indications shows Negative': 'Toutes les Autres Indications Montrent Négatif',
  'Patient Indicated': 'Indiqué par le Patient',
  'Electronically Signed By': 'Signé Électroniquement Par',
  'Lic': 'Lic',
  'Surgeon': 'Chirurgien',
  'Anesthesiologist': 'Anesthésiologue',
  'Nurse': 'Infirmière',
  'Since Birth': 'Depuis la Naissance',
  'Year(s)': 'An(s)',
  'Week(s)': 'Semaine(s)',
  'Month(s)': 'Mois',
  'Day(s)': 'Jour(s)',
  'Hours': 'Heures',
  'Mild': 'Léger',
  'Moderate': 'Modéré',
  'Severe': 'Sévère',
  'Provisional': 'Provisoire',
  'Resolved': 'Résolu',
  'RuledOut': 'Écarté',
  'Not Examined': 'Non Examiné',
  'Entered In Error': 'Saisi par Erreur',
  // ── Common ──
  'N/A': 'S/O',
};